import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import classes from './Options.module.css'
import OptionAggregate from './OptionAggregate'
import ProductModifiers from './ProductModifiers'
import { productDetailsActions } from "../../../store/productDetails"


const selectTheFirstItem = (arr, skip) => {
    if (!skip) {
        arr[0] = {...arr[0], itemSelected: true}
    }

    if (arr[0].modifiers) {
        arr[0].modifiers.forEach(mod => {
            if (mod.mandatory) {
                selectTheFirstItem(mod.options)
            } else {
                selectTheFirstItem(mod.options, true)
            } 
        })
    }
}

const removeTheFirstItem = (arr) => {
    arr[0] = {...arr[0], itemSelected: false}
    if (arr[0].modifiers) {
        arr[0].modifiers.forEach(mod => {
            if (mod.mandatory) {
                selectTheFirstItem(mod.options)
            }
        })
    }
}
const removeAllSelectedItems = (arr) => {
    arr.forEach(item => {
        if (item.options) {
            item.options.forEach(option => {
                if (!option.itemSelected) {
                    if (option.modifiers) {
                        option.modifiers.forEach(mod => {
                            mod.options.forEach(suboption => {
                                suboption.itemSelected = false
                                suboption.selectedQuantity = 0
                            })                            
                        })
                        removeAllSelectedItems(option.modifiers)
                    }
                }
            })
        }
    })
}
function searchForId(dataToSearch, parentModifierID, optionID) {
    let foundIndex = dataToSearch.findIndex(x => x.id === parentModifierID); 
    removeAllSelectedItems(dataToSearch)   
    dataToSearch.forEach(item => item.itemSelected = false)
    if (foundIndex >=0 ) {
        dataToSearch[foundIndex].options.forEach(f => {
            if (f.id === optionID) {
                f.itemSelected = true
                if (f.modifiers) {
                    f.modifiers.forEach(m => {
                        if (m.mandatory) {
                            selectTheFirstItem(m.options)
                        } else {
                            selectTheFirstItem(m.options, true)
                        }
                    })
                }
            } else {
                f.itemSelected = false
            }
        })
    } else {        
        dataToSearch.forEach(element => {
            element.options.forEach(option => {
                if (option.modifiers) {
                    searchForId(option.modifiers, parentModifierID, optionID)                   
                }
            });
        });
    }

    return dataToSearch
}

function searchForIdNotRequired(dataToSearch, parentModifierID, optionID) {
    let foundIndex = dataToSearch.findIndex(x => x.id === parentModifierID);  
 
    removeAllSelectedItems(dataToSearch) 
    // dataToSearch.forEach(item => item.itemSelected = false)
    if (foundIndex >=0 ) {
        dataToSearch[foundIndex].options.forEach(f => {
            if (f.id === optionID) {
                if (!f.itemSelected) {
                    f.itemSelected = true
                    if (f.modifiers) {
                        f.modifiers.forEach(m => {
                            if (m.mandatory) {
                                selectTheFirstItem(m.options)
                            } else {
                                selectTheFirstItem(m.options, true)
                            }
                        })
                    }  
                } else {
                    f.itemSelected = false
                    f.selectedQuantity = 0
                    if (f.modifiers) {
                        f.modifiers.forEach(m => {
                            removeTheFirstItem(dataToSearch) 
                        })
                    } 
                }                           
            } 
        })
    } else {       
        dataToSearch.forEach(element => {
            element.options.forEach(option => {
                if (option.modifiers) {
                    searchForIdNotRequired(option.modifiers, parentModifierID, optionID)                   
                }
            });
        });
    }
    
    return dataToSearch
}

function incrementOption(dataToSearch, parentModifierID, optionID) {
    let foundIndex = dataToSearch.findIndex(x => x.id === parentModifierID);

    if (foundIndex >=0 ) {
        dataToSearch[foundIndex].options.forEach(f => {
            if (f.id === optionID) {
                f.selectedQuantity = (f.selectedQuantity ? f.selectedQuantity : 0) + 1             
            } 
        })
    } else {        
        dataToSearch.forEach(element => {
            element.options.forEach(option => {
                if (option.modifiers) {
                    incrementOption(option.modifiers, parentModifierID, optionID)                   
                }
            });
        });
    }

    return dataToSearch
}

function decrementOption(dataToSearch, parentModifierID, optionID) {
    let foundIndex = dataToSearch.findIndex(x => x.id === parentModifierID);

    if (foundIndex >=0 ) {
        dataToSearch[foundIndex].options.forEach(f => {
            if (f.id === optionID) {
                if (f.selectedQuantity) {
                    f.selectedQuantity = f.selectedQuantity - 1
                } else {
                    f.selectedQuantity = 0
                }
                             
            } 
        })
    } else {        
        dataToSearch.forEach(element => {
            element.options.forEach(option => {
                if (option.modifiers) {
                    decrementOption(option.modifiers, parentModifierID, optionID)                   
                }
            });
        });
    }

    return dataToSearch
}



const OptionsAggregate = ({options, parentModifier}) => {
    const dispatch = useDispatch()
    const productDetails = useSelector(state => state.productDetails.data)
    const [limitReached, setLimitReached] = useState(false)
    const [totalSelecteditems, setTotalSelecteditems] = useState(0)
    
    const editOptions = useSelector(state => state.productDetails.edit)
    const pageReload = useSelector(state => state.productDetails.pageReload)

    const selectedNumbersIncrementHandler = (id) => {
        let data = JSON.parse(JSON.stringify(productDetails));
        setTotalSelecteditems(prevState => prevState = prevState + 1)
        const incrementedOptions = incrementOption(data, parentModifier.id, id)
        dispatch(productDetailsActions.createProduct(incrementedOptions))
    }

    const selectedNumbersDecrementHandler = (id) => {
        let data = JSON.parse(JSON.stringify(productDetails));
        setTotalSelecteditems(prevState => prevState = prevState -1)
        const decrementedOptions = decrementOption(data, parentModifier.id, id)
        dispatch(productDetailsActions.createProduct(decrementedOptions))
    }

    const setOptionHandler = (id, incrementDecrement) => {
        let data = JSON.parse(JSON.stringify(productDetails));
        
        if (parentModifier.mandatory) {
       
            const modifiedData = searchForId(data, parentModifier.id, id)
            if (incrementDecrement === 'increment') {
                setTotalSelecteditems(prevState => prevState = prevState + 1)
                const incrementedOptions = incrementOption(modifiedData, parentModifier.id, id)
                dispatch(productDetailsActions.createProduct(incrementedOptions))
            } else if (incrementDecrement === 'decrement') {
                setTotalSelecteditems(prevState => prevState = prevState -1)
                const decrementedOptions = decrementOption(data, parentModifier.id, id)
                dispatch(productDetailsActions.createProduct(decrementedOptions))
            }
            // dispatch(productDetailsActions.createProduct(modifiedData))
        } else {
            const modifiedDataNotRequired = searchForIdNotRequired(data, parentModifier.id, id)
            if (incrementDecrement === 'increment') {
                setTotalSelecteditems(prevState => prevState = prevState + 1)
                const incrementedOptions = incrementOption(modifiedDataNotRequired, parentModifier.id, id)
                dispatch(productDetailsActions.createProduct(incrementedOptions))
            } else if (incrementDecrement === 'decrement') {
                // setTotalSelecteditems(prevState => prevState = prevState -1)
                const decrementedOptions = decrementOption(data, parentModifier.id, id)
                dispatch(productDetailsActions.createProduct(decrementedOptions))
            }
            // dispatch(productDetailsActions.createProduct(modifiedDataNotRequired))
        }        
        
    }

    useEffect(() => {
        if (parentModifier.maxselects) {
            const selectedOptions = options.filter(option => option.itemSelected)
            if (selectedOptions.length >= parentModifier.maxselects) {
                setLimitReached(true)
            } else {
                setLimitReached(false)
            }
        }

        
    }, [options])

    useEffect(() => {
        if (!((parentModifier.maxaggregatequantity - totalSelecteditems) > 0)) {
            setLimitReached(true)
        } else {
            setLimitReached(false)
        }
    }, [parentModifier.maxaggregatequantity, totalSelecteditems])


    useEffect(() => {        
        if (editOptions) {

            let selectedEditOptions = []
            options.forEach(element => {
                if (editOptions.choices.find(item => item.optionid === element.id)) {
                    selectedEditOptions.push(editOptions.choices.find(item => item.optionid === element.id))
                }
            });         

            if (selectedEditOptions.length > 0) {
                // let total = selectedEditOptions.map(item => item.quantity)
                // let total = selectedEditOptions.reduce(reducer)
                let total = 0
                selectedEditOptions.forEach(item => {
                    total = total + item.quantity
                })
                setTotalSelecteditems(total)
            }            
        }
    }, [pageReload])
    
    const totalSelectableItems = (parentModifier.maxaggregatequantity - totalSelecteditems) > 0 ? parentModifier.maxaggregatequantity - totalSelecteditems : 0

    return <>
        {options && <div className={`${classes.options_container} grid-5`}>
            {options.map(option => (
                <OptionAggregate key={option.id} option={option} setOption={setOptionHandler} selecteditemsIncrement={selectedNumbersIncrementHandler} selectedNumbersDecrement={selectedNumbersDecrementHandler} totalSectable={totalSelectableItems} limitReached={limitReached}/>
            ))}    
        </div>}

        {options.filter(option => option.itemSelected).map(item => (
            <div key={item.id}>{item.modifiers && item.modifiers.length > 0 && <ProductModifiers modifiers={item.modifiers}/>}</div>
        ))}
    </>
}

export default OptionsAggregate